export default "__VITE_ASSET__3d6a0cc8__"